var _ = require("lodash");
var dd = require("react-dd");
var Select = require("react-loose-forms.bootstrap3/inputs/Select").component;

var getCountryList = function(Displaylists){
	var u_lists = (Displaylists && Displaylists.universal) || {};
	return u_lists.countrylist || {};
};

module.exports = {
	component: dd.createClass({
		render: function(){
			var field = _.cloneDeep(_.omit(this.props.field, "Displaylists"));

			field.options = _.object(_.map(getCountryList(this.props.field.Displaylists), function(country){
				return [country.sc, country.lc];
			}));
			field.dont_sort_options = true;//It should come pre-sorted from the server
			if(!_.isString(field.placeholder)){
				field.placeholder = "-- select country --";
			}

			return Select(_.assign({}, this.props, {
				field: field
			}));
		}
	}),
	validate: function(value){
		return !!value || "Please select a country";
	}
};



//////////////////
// WEBPACK FOOTER
// ./~/ES/inputs/esCountry.js
// module id = 172
// module chunks = 0 1 2 3 4